import React, {useContext, useEffect, useState} from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { getTbNameByJobName, isMasterJob, JobNames } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { aiCenterList, TableColumn, TableSettings } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { AiCenterListItem } from '../../fms.data/models/AiCenterListItem';
import ApplicationContext from '../../ApplicationContext';
import { SiteLogType } from '../../fms.enum';
import { getDetailSecLinkInfo, getJobNameBySourceType } from '../../util';
import { useSecureNavigate } from '../../hooks/useSecureNavigate';
import useJobMenus from '../../hooks/useJobMenus';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import LeftRightSplit from '../../ui/LeftRightSplit';
import Select from '../../ui/Select';
import aiapi from '../../aiapi';
import { apiCallResolver } from '../../api/ifmsApi';
import { getApiKey } from '../../apiKeyProvider';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import { isAiCenterOff } from '../../aiCenterFlags';
import arrowFatDownBlack from '../../img/arrow-fat-down-black.svg';
import arrowFatDownWhite from '../../img/arrow-fat-down-white.svg';
import envelopeSimpleBlack from '../../img/envelope-simple-black.svg';
import envelopeSimpleWhite from '../../img/envelope-simple-white.svg';

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function AiCenterListCommands() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [listResultFilter, setListResultFilter] = useTypedFastStorage<number>('aiCenter-result-ListFilter', 0);

  useEffect(() => {
    changeListResultItem(listResultFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ listResultFilter]);

  function changeListResultItem(listResultFilter: number){
    jobListContext.setListFilterType2(listResultFilter);
  }

  return (
    <>
     <div className='ifms-common-no-vertical-separator-gap-margin'>
        <div className='ifms-common-vertical-gap-8'>
          {/* <span style={{fontSize:'12px', padding:'4px 10px',backgroundColor: '#f6f5f2', borderRadius: '999px', marginRight:'4px'}}>⇩ Dropped</span>
          <span style={{fontSize:'12px', padding:'4px 10px',backgroundColor: '#f6f5f2', borderRadius: '999px'}}>✉ Intake</span> */}
          <span style={{fontSize:'12px', padding:'4px 10px', marginRight:'4px', display: 'inline-flex', alignItems: 'center', gap: '4px', color: appContext.useDarkMode ? 'white' : 'black'}}>
            <img src={appContext.useDarkMode ? arrowFatDownWhite : arrowFatDownBlack} alt="" width={14} height={14} />
            Drag & Drop
          </span>
          <span style={{fontSize:'12px', padding:'4px 10px', display: 'inline-flex', alignItems: 'center', gap: '4px', color: appContext.useDarkMode ? 'white' : 'black' }}>
            <img src={appContext.useDarkMode ? envelopeSimpleWhite : envelopeSimpleBlack} alt="" width={14} height={14} />
            Intake
          </span>
        </div>
        <div style={{marginLeft:'10px', marginTop:'10px', width:'120px',display:'inline-block'}}>
          <LeftRightSplit
            leftSize={'40px'}
            rightSize={'80px'}
            left={<label style={{color: appContext.useDarkMode ? 'white': 'black',lineHeight:'16px'}}>Result</label> }
            right={
              <div style={{lineHeight:'14px', maxHeight:'300px',}}>
              <Select
                name="ifms-aicenter-list-result-filter"
                value={listResultFilter ?? 0}
                items={[
                  {value: 0, label:'All'},
                  {value: 1, label:'B/L'},
                  {value: 2, label:'Invoice'},
                  {value: 3, label:'Bill'},
                  {value: 4, label:'CrDb'},
                  {value: 5, label:'ISF'},
                ]}
              onChange={e => {setListResultFilter(Number(e.target.value))}}
              />
              </div>
            }
          />
        </div>
      </div>
    </>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  //const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <></>
  );
}

function SenderRenderer({cell, row, data}: any) {
  const l = data[row.index];
  const isDrop = l.source === 'DROP';
  return (
    <div
      id={`${cell.column.id}-${row.index}`}
      className="ifms-table-align-left"
      style={{display:'flex', alignItems:'center', gap:'4px'}}
    >
      <img src={isDrop ? arrowFatDownBlack : envelopeSimpleBlack} alt="" width={14} height={14} style={{flexShrink: 0}} />
      <span style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{cell.value}</span>
    </div>
  );
}

function ActionRenderer({cell, row, data}: any){
  const l = data[row.index];
  const appContext = useContext(ApplicationContext);
  const secureNavigate = useSecureNavigate();
  const { moveToSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);


  async function gotoDetail(){

    //debugger;
    if(l.shipmentId){
      try {
        // const apiResult = await appContext.api.getIsfLink('', l.jobId, l.isfType);
        // if (apiResult && apiResult.success) {
        //   //apiResult.result.item2 : auto Login 여부 (1 : true, 0: false)
        //   if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.IsfWeb, apiResult.result.item2 ? 1 : 0);
        //   //window.open('https://imanifest.suntekscm.com/Home/AutoLoginFms?args=' + apiResult.result.item1);
        //   window.open('https://imantest.suntekscm.co.kr/Home/AutoLoginFms?args=' + apiResult.result.item1); // Test
        //   // window.open('http://localhost:4649/Home/AutoLoginFms?args=' + apiResult.result.item1); // Debug
        // }
        // SWITCH TO ISF LIST
        jobListContext.setFilterForScreenExternally('/common/joblistview/ISFL/isf',
          'id', '', l.jobId, 'modifyDate', false, true, null, 'shipmentId', l.shipmentId, false, true);  
        openNewPage(history, `/common/joblistview/ISFL/isf`, NavigationType.newPage);
      } catch (error) {
        console.error('ISF Detail Error:', error);
      }
    }
    else {
      //let blJobName = getJobNameBySourceType(l.type); // [Inv, Bill, CrDb : ParentJobName, BL : JobName]
      //let jobName = blJobName; 
      //let jobId = isMasterJob(jobName) ? l.mblId : l.hblId;

      //if(['Invoice', 'Bill', 'CrDb'].includes(l.category)){
        // switch (l.category) {
        //   case 'Invoice': jobName = JobNames.Invoice; break;
        //   case 'Bill': jobName = JobNames.Bill; break;
        //   case 'CrDb': jobName = JobNames.CrDb; break;
        // }
        //jobId = l.invoiceId;
      //}

      //const {secTask, detailUrl } = getDetailSecLinkInfo(jobName, jobId,  l.parentTbId, getTbNameByJobName(blJobName));
      
      //Id가 존재하는지 확인
      const isExistId = await appContext.api.existListId(l.jobId, l.jobName);
      if(!isExistId) {
        await showGlobalOkDialog(<p>Can not go to Detail.</p>);
        return;
      }

      const {secTask, detailUrl} = getDetailSecLinkInfo(l.jobName, l.jobId, l.parentJobId, getTbNameByJobName(l.parentJobName));
      if(!secTask || !detailUrl) return;
        secureNavigate(secTask, () =>
          moveToSingleOpenedScreenInAnyOperationStartingWithUrl(detailUrl, [detailUrl, detailUrl.replace('/view', '/edit')])
        );
    }
  }

  return <div onClick={async() => await gotoDetail()} id={`${cell.column.id}-${row.index}`} style={{width: '100%', color: '#0F79FF', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer', textAlign:'left'}}>{cell.value}</div>;
}


/**
 *
 * @class AiCenterListView
 * @extends {AbstractListView}
 */
class AiCenterListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType?: string, user?: any, jobListViewContext?: any, showLoading: boolean = true): Promise<DataFetchResult> {
    // AI Settings 에서 AI Center 가 꺼져 있으면 목록을 불러오지 않는다 (화면은 경고 후 닫힌다 — JobListView)
    if (isAiCenterOff()) {
      return {data: [], totalCount: 0};
    }
    // const apiResult = await api.getListItems(
    //   JobNames.AICenter,
    //   'AiCenterListItem',
    //   AiCenterListItem.calculateSearchParameters(search,AiCenterListItem.MapSearchFields),
    //   pageNum,
    //   limit,
    //   search.pageSize,
    //   search.pagePerBatch,
    //   undefined,        // other
    //   undefined,        // listFilterType
    //   showLoading       // AI Drop Zone에서 Toast Message 띄우면서 AI Center List를 갱신할떄 화면이 깜빡여서 추가
    // );
    //const searchParam = AiCenterListItem.calculateSearchParameters(search, AiCenterListItem.MapSearchFields);
    //const aiCenterListItem = new AiCenterListItem();
    const apiResult = await apiCallResolver(() => aiapi.post(
      'api/emailjob/list', {
        searchModel: AiCenterListItem.calculateSearchParameters(search, AiCenterListItem.MapSearchFields),
        limit,
        start: (pageNum - 1) * 30,        
      },
      {
        headers: {
          'ApiKey': getApiKey(),
          'Content-Type': 'application/json'
        }
      }
    ), true, true);

    if (!apiResult.success || !apiResult.data.entities || apiResult.data.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: AiCenterListItem.formatData(apiResult.data.entities), totalCount: apiResult.data.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AICenter, 'AiCenterListItem',
      AiCenterListItem.calculateSearchParameters(search, AiCenterListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  AiCenterListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AiCenterListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.dataIndex === "sender") colRenderer.Cell = SenderRenderer;
      else if(x.dataIndex === "actionNo") colRenderer.Cell = ActionRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  aiCenterList;
    const cols = AiCenterListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <AiCenterListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  
  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: AiCenterListItem) {
    return '';
  }

  getListViewTitle() {
    return 'AI Center';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AICenter} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

}

export default AiCenterListView;